import _ from "lodash";
import { confirmStatusCheckboxOption } from "presentation/constant/CheckBox/StaticCheckboxOptions";
import { approvalProcessStatusDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ProposalEnquiryConstant } from "presentation/constant/ProposalEnquiry/ProposalEnquiryConstant";
import { useProposalEnquiryVM } from "presentation/hook/ProposalEnquiry/useProposalEnquiryVM";
import { useProposalEnquiryTracked } from "presentation/store/ProposalEnquiry/ProposalEnquiryProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import {
    CommonField,
    FieldType,
    GroupCheckboxList,
    HPHGroupCheckbox,
    IFieldValue
} from "veronica-ui-component/dist/component/core";


export const ProposalEnquiryCriteriaEditPanel = () => {
    //const CHARGE_CONSTANT = ChargeConstant.Charge;
    const PROPOSAL_ENQ_HDR_CONST = ProposalEnquiryConstant.Header;
    const [proposalEnquiryState] = useProposalEnquiryTracked();
    const searchCriteria = proposalEnquiryState.searchCriteria;
    const proposalEnquiryVM = useProposalEnquiryVM();
    // const enabledCriteria = useMemo(() => CriteriaDirectoryVoyageCheckboxOption?.find(item => proposalEnquiryState.enabledSearchCriteria[item.key]), [proposalEnquiryState.enabledSearchCriteria]);

    const { dynamicOptions } = proposalEnquiryState;

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.companyCode?.join(',')}
                fieldValue={searchCriteria.companyCode}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isMultipleDropDown={true}
                options={proposalEnquiryState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.COMPANY_CODE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.companyCode?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    proposalEnquiryVM.onMultipleDropdownChange(e, 'companyCode')
                }}
                options={proposalEnquiryState.dynamicOptions.companyCodeDropdownOptions} /> */}
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.COMPANY_CODE, proposalEnquiryState.dynamicOptions.companyCodeDropdownOptions, proposalEnquiryVM, searchCriteria.companyCode])

    const memoProposalNo = useMemo(() =>
        /*<div className='im-flex-row-item'>
            <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.PROPOSAL_NO}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria?.proposalNo??''}
                onChange={(e:any) => {
                    proposalEnquiryVM.onMultipleDropdownChange(e, 'proposalNo')
                }}
                />
        </div>*/
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.proposalNo || ''}
                fieldValue={searchCriteria.proposalNo}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={15}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.PROPOSAL_NO, proposalEnquiryVM, searchCriteria?.proposalNo])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.operatingTml?.join(',')}
                fieldValue={searchCriteria.operatingTml}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.OPERATING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                isMultipleDropDown={true}
                options={proposalEnquiryState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.OPERATING_TML}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.operatingTml?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    proposalEnquiryVM.onMultipleDropdownChange(e, 'operatingTml')
                }}
                options={proposalEnquiryState.dynamicOptions.operatingTmlDropdownOptions} /> */}
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.OPERATING_TML, proposalEnquiryState.dynamicOptions.operatingTmlDropdownOptions, proposalEnquiryVM, searchCriteria.operatingTml])

    const memoEffectiveDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={PROPOSAL_ENQ_HDR_CONST.EFFECTIVE_DATE_RANGE}
                width="330px"
                fieldNames={{ startField: "effectiveFromDate", endField: "effectiveToDate" }}
                dateRange={{ startDate: searchCriteria.effectiveFromDate, endDate: searchCriteria.effectiveToDate }}
                onDatesChange={proposalEnquiryVM.onDateRangeChange}
            />
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.EFFECTIVE_DATE_RANGE, searchCriteria.effectiveFromDate, searchCriteria.effectiveToDate, proposalEnquiryVM.onDateRangeChange])

    const memoTariffCodeOptions = useMemo(() => {
        const groupOfTariffCodeOptions = searchCriteria.tariffType?.map(tariffType => proposalEnquiryState.dynamicOptions.tariffCodeDropdownOptions[tariffType]);
        const commonTariffCodeOptions = _.orderBy(_.uniqBy(_.flatMap(_.concat(groupOfTariffCodeOptions ?? [])), 'value'), 'dropdownLabel');
        return commonTariffCodeOptions;
    }, [searchCriteria.tariffType, proposalEnquiryState.dynamicOptions.tariffCodeDropdownOptions])

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.tariffType?.join(',')}
                fieldValue={searchCriteria.tariffType}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.TAR_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                maxLength={60}
                isMultipleDropDown={true}
                options={proposalEnquiryState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.TAR_TYPE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.tariffType?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => {
                    proposalEnquiryVM.onMultipleDropdownChange(e, 'tariffType')
                    proposalEnquiryVM.onDropdownChange(EMPTY_PROPOSAL_ENQUIRY_SEARCH_CRITERIA.tariffCode, 'tariffCode')
                }}
                options={proposalEnquiryState.dynamicOptions.tariffTypeDropdownOptions} /> */}
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.TAR_TYPE, searchCriteria.tariffType, proposalEnquiryState.dynamicOptions.tariffTypeDropdownOptions, proposalEnquiryVM])

    const memoTariffCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.tariffCode?.join(',')}
                fieldValue={searchCriteria.tariffCode}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.TAR_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffCode'}
                maxLength={60}
                isMultipleDropDown={true}
                options={memoTariffCodeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.TAR_CODE}
                width='150px'
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.tariffCode?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => proposalEnquiryVM.onMultipleDropdownChange(e, 'tariffCode')
                }
                options={memoTariffCodeOptions} /> */}
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.TAR_CODE, searchCriteria.tariffCode, memoTariffCodeOptions, proposalEnquiryVM])


    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                sort={false}
                readOnlyValue={searchCriteria.proposalStatus?.join(',')}
                fieldValue={searchCriteria.proposalStatus}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.STATUS}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalStatus'}
                maxLength={60}
                isMultipleDropDown={true}
                options={approvalProcessStatusDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            {/* <NbisInputDropDown
                label={PROPOSAL_ENQ_HDR_CONST.STATUS}
                width="330px"
                inputType="freeText"
                mode={'multiple'}
                sort={false}
                value={searchCriteria.proposalStatus?.map((item) => ({
                    value: item
                }))}
                onChange={(e: any) => proposalEnquiryVM.onMultipleDropdownChange(e, 'proposalStatus')}
                options={approvalProcessStatusDropdownOption} /> */}
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.STATUS, searchCriteria.proposalStatus, proposalEnquiryVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <CommonField
                isReadOnly={false}
                isShowOptional={false}
                isMultipleDropDown={false}
                //disableInput={true}
                fieldValue={searchCriteria?.activeInd ?? ''}
                fieldLabel={PROPOSAL_ENQ_HDR_CONST.ACTIVE_IND}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'activeInd'}
                options={dynamicOptions.activeIndDropdownOption}
                maxLength={40}
                sort={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalEnquiryVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [PROPOSAL_ENQ_HDR_CONST.ACTIVE_IND, proposalEnquiryVM, searchCriteria?.activeInd, dynamicOptions.activeIndDropdownOption])

    const memoConfirmStatus = useMemo(() =>
        <>
            <div className='im-flex-row-item'>
                <HPHGroupCheckbox
                    label={PROPOSAL_ENQ_HDR_CONST.CONFIRM_STATUS}
                    checkboxData={confirmStatusCheckboxOption}
                    selectedValues={searchCriteria.confirmStatusList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => proposalEnquiryVM.onGroupCheckboxChange(e, "confirmStatusList")}
                />
            </div>
        </>
        , [PROPOSAL_ENQ_HDR_CONST.CONFIRM_STATUS, searchCriteria.confirmStatusList, proposalEnquiryVM])


    return (
        <div className='im-charge-data-search-criteria-group'>
            <CriteriaItemContainer>
                {memoCompanyCode}
                {memoProposalNo}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoOperatingTml}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoEffectiveDateFromTo}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoTariffType}
                {memoTariffCode}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoStatus}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoActiveInd}
            </CriteriaItemContainer>
            <CriteriaItemContainer>
                {memoConfirmStatus}
            </CriteriaItemContainer>
        </div>
    );
};
